import { ArrowForwardIcon } from '@chakra-ui/icons'
import { Button } from '@chakra-ui/react'
import { useAuth } from '@hb/react'
import { Link } from 'react-router-dom'

export const MyAssessmentShortcut = () => {
  const authUser = useAuth(s => s.authUser)
  return authUser ? (
    <Link to="/pregnancy">
      <Button
        fontFamily="Comfortaa"
        bg="whiteAlpha.700"
        _hover={{ bg: 'whiteAlpha.800' }}
        _dark={{ bg: 'blackAlpha.800', _hover: { bg: 'blackAlpha.900' }, color: 'gray.200' }}
        color="gray.600"
        shadow="md"
        size="sm"
        position="absolute"
        top={5}
        right={5}>
        My Assessment <ArrowForwardIcon ml={1} />
      </Button>
    </Link>
  ) : null
}
